import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectPaymentDataByType } from '../../../../selectors/paymentProcessing';
import { checkPaymentStatusThunk } from '../../../../thunks/payment/checkPaymentStatus';
import { EPaymentType } from '../../../../types/reducers/paymentProcessing';
import { PaymentStatusCanceled } from './PaymentStatusCanceled';
import { Link } from '../../../common/Link';

export const PaymentStatusCanceledContainer = () => {
  const payment = useSelector(selectPaymentDataByType(EPaymentType.Publish))!;

  const dispatch = useDispatch();

  const handleRetryClick = React.useCallback(async () => {
    const { paymentId, provider } = payment;

    await dispatch(checkPaymentStatusThunk({ type: EPaymentType.Publish, paymentId, provider }));
  }, [dispatch, payment]);

  const content = (
    <>
      Деньги ещё не поступили на счёт. <Link onClick={handleRetryClick}>Обновить</Link>
    </>
  );

  return <PaymentStatusCanceled content={content} />;
};
